angular.module('picmonic-common').factory('MarketSelectorModalService', [
  '$modal',
  '$cookies',
  '$stateParams',
  'MarketOptionsConfig',
  'UserService',
  function ($modal, $cookies, $stateParams, MarketOptionsConfig, UserService) {
    return {
      showMarketSelectorModal: function (market, setCookie, skipRedirect) {
        var marketUrl = null;
        (nextPage = '/find-picmonic'), (redirect = skipRedirect ? false : true);

        if (market) {
          var marketObj = MarketOptionsConfig.getMarketByName(market);
          marketUrl =
            nextPage +
            '?market=' +
            marketObj.slug +
            ($stateParams.pathway ? '&pathway=' + $stateParams.pathway : '') +
            ($stateParams.path ? '&path=' + $stateParams.path : '') +
            ($stateParams.pathway_type ? '&pathway_type=' + $stateParams.pathway_type : '') +
            ($stateParams.curriculum ? '&curriculum=' + $stateParams.curriculum : '') +
            '&noMarketModal';
        } else if ($cookies.get('pls_user_lead')) {
          var userMarket = MarketOptionsConfig.getMarketById($cookies.get('pls_user_lead'));
          if (userMarket.slug) {
            marketUrl =
              nextPage +
              '?market=' +
              userMarket.slug +
              ($stateParams.pathway ? '&pathway=' + $stateParams.pathway : '') +
              ($stateParams.path ? '&path=' + $stateParams.path : '') +
              ($stateParams.pathway_type ? '&pathway_type=' + $stateParams.pathway_type : '') +
              ($stateParams.curriculum ? '&curriculum=' + $stateParams.curriculum : '') +
              '&noMarketModal';
          }
        }

        if (marketUrl && redirect) {
          window.location.href = marketUrl;
          return;
        } else if (UserService.user.user_id && UserService.user.lead && redirect) {
          userMarket = MarketOptionsConfig.getMarketById(UserService.user.lead);
          if (userMarket.slug) {
            window.location.href =
              nextPage +
              '?market=' +
              userMarket.slug +
              ($stateParams.pathway ? '&pathway=' + $stateParams.pathway : '') +
              ($stateParams.path ? '&path=' + $stateParams.path : '') +
              ($stateParams.pathway_type ? '&pathway_type=' + $stateParams.pathway_type : '') +
              ($stateParams.curriculum ? '&curriculum=' + $stateParams.curriculum : '') +
              '&noMarketModal';
            return;
          }
        }

        return $modal.open({
          templateUrl: '/templates/public/modals/market-selector.html',
          windowClass: 'market-selector',
          backdrop: 'static',
          keyboard: false,
          controller: [
            '$scope',
            '$filter',
            '$modalInstance',
            'MarketOptionsConfig',
            '$location',
            function ($scope, $filter, $modalInstance, MarketOptionsConfig, $location) {
              $scope.fpt = !!$location.search().fpt;
              $scope.title = $scope.fpt ? 'I want free access to Picmonic for...' : 'My area of study...';
              $scope.markets = $filter('orderBy')(
                $filter('filter')(MarketOptionsConfig.markets, { has_pricing: 1 }, true),
                'order'
              );

              $scope.selectMarket = function (market) {
                $scope.selectedMarket = market.title == $scope.selectedMarket ? '' : market.title;
              };

              $scope.selectLead = function (lead) {
                if (setCookie) {
                  var slug = 'medicine';
                  var queryString = lead.url && lead.pricing_url.substring(lead.url.indexOf('?') + 1);

                  if (!queryString) {
                    slug = lead.slug;
                  } else if (queryString.indexOf('/pricing/') > -1) {
                    slug = queryString.substring(queryString.indexOf('/pricing/') + 9);
                  } else if (queryString.indexOf('&') > -1) {
                    slug = queryString.substring(queryString.indexOf('market=') + 7, queryString.indexOf('&'));
                  } else {
                    slug = queryString.substring(queryString.indexOf('market=') + 7);
                  }

                  $cookies.put('pls_user_lead', MarketOptionsConfig.getMarketBySlug(slug).id);
                  $scope.$close();
                } else {
                  if (lead.url) {
                    window.location = lead.url;
                  } else if (lead.id === 108) {
                    window.location =
                      '/pathways/medical-terminology/courses/standard/medical-terminology-2411?market=medical-terminology';
                  } else {
                    window.location = '/find-picmonic?market=' + lead.slug;
                  }
                }
              };

              $scope.goToUrl = function (url) {
                window.location.href = url;
              };
            },
          ],
        });
      },
    };
  },
]);
